<ng-container *ngIf="!!calloutBlock && calloutBlock?.length">
  <div class="jb-max-width center">
    <div
      class="jb-grid mv6 jb-callout-block"
      [ngClass]="{
        'one-up': calloutBlock?.length === 1,
        'two-up grid-offset': calloutBlock?.length === 2,
        'three-up': calloutBlock?.length === 3,
        'four-up': calloutBlock?.length > 3
      }"
    >
      <ng-container
        *ngFor="let block of calloutBlock; let i = index"
        class="image-container"
      >
        <jb-callout-block [attr.data-order]="i + 1">
          <jb-image
            src="{{ (block?.image)[0]?.src }}"
            *ngIf="!!block?.image && (block?.image)[0]?.src"
            [defer]="true"
            [height]="
              hasImageHeightWidthAttr && +block?.image[0]?.height > 0
                ? (block?.image)[0]?.height
                : null
            "
            [width]="
              hasImageHeightWidthAttr && +block?.image[0]?.width > 0
                ? (block?.image)[0]?.width
                : null
            "
            [placeholder]="
              (block?.image)[0]?.src
                | dynamicImageWidthPipe: 'placeholder':placeholderParams
            "
            [isLazy]="enableLazyLoadImage"
          >
          </jb-image>

          <jb-icon
            name="{{ (block?.icon)[0]?.src }}"
            *ngIf="!!block?.icon && (block?.icon)[0]?.src"
          >
          </jb-icon>
          <ng-container JbTitle>
            <h3>{{ block?.title }}</h3>
          </ng-container>
          <ng-container JbDescription> {{ block?.description }} </ng-container>
          <a
            *ngIf="!!block?.link && block?.link?.length"
            [dotLinkIcon]="(block?.link)[0]?.newWindow"
            (click)="onClick($event, block?.link[0]?.showChat)"
            [jbSitemapLinker]="
              block?.link[0]?.href
                ? block?.link[0]?.href
                : block?.link[0]?.showChat === 'true'
                ? 'ASAPP'
                : 'null'
            "
            jbActionLink
            >{{ (block?.link)[0]?.title }}</a
          >
        </jb-callout-block>
      </ng-container>
    </div>
  </div>
</ng-container>
